// Notifications
export const NOTIFICATIONS_LIST_STORE = 'notificationsListStore'
// Jobs
export const VEHICLES_LIST_STORE = 'vehiclesListStore'
export const CUSTOMERS_LIST_STORE = 'customersListStore'
export const TRAILERS_LIST_STORE = 'trailersListStore'
export const EMPLOYEES_LIST_STORE = 'employeesListStore'
export const HAULAGE_JOBS_LIST_STORE = 'haulageJobsListStore'
export const DIGESTATE_JOBS_LIST_STORE = 'digestateJobsListStore'
export const SPREADING_JOBS_LIST_STORE = 'spreadingJobsListStore'
export const FIELDS_LIST_STORE = 'fieldsListStore'
export const FARMS_LIST_STORE = 'farmsListStore'
export const SERVICES_LIST_STORE = 'servicesListStore'
export const DELIVERY_SITES_STORE = 'deliverySitesListStore'
export const WASTE_DELIVERY_SITES_STORE = 'wasteDeliverySitesListStore'
export const COLLECTION_SITES_STORE = 'collectionSitesListStore'
export const PRODUCTS_LIST_STORE = 'productsListStore'
export const SILOS_LIST_STORE = 'silosListStore'
export const SILOS_HISTORY_LIST_STORE = 'silosHistoryListStore'
export const SILOS_INSPECTIONS_LIST_STORE = 'silosInspectionsListStore'
export const TIMESHEETS_LIST_STORE = 'timesheetsListStore'
export const VEHICLE_INSPECTIONS_LIST_STORE = 'vehicleInspectionsList'
export const VEHICLE_FUEL_ENTRIES_LIST_STORE = 'vehicleFuelEntriesList'
export const VEHICLE_DEF_ENTRIES_LIST_STORE = 'vehicleDefEntriesList'
export const ASSIGNED_FARMS_FIELDS_LIST = 'assignedFarmsFieldList'
export const ASSIGNED_FARMS_SILOS_LIST = 'assignedFarmsSilosList'
export const FARMS_DROPDOWN_LIST = 'farmsToAssignListStore'
export const ASSIGNED_FARMS_SILOS_DROPDOWN_LIST = 'farmSilosToAssignListStore'
export const ASSIGNED_FARMS_FIELDS_DROPDOWN_LIST = 'farmFieldsToAssignListStore'
export const PRODUCT_DROPDOWN_LIST = 'productToAssignListStore'
export const EMPLOYEE_DROPDOWN_LIST = 'employeeToAssignListStore'
export const CUSTOMER_DROPDOWN_LIST = 'customerToAssignListStore'
export const SERVICES_DROPDOWN_LIST = 'servicesToAssignListStore'
export const VEHICLE_DROPDOWN_LIST = 'vehicleToAssignListStore'
export const TRAILER_DROPDOWN_LIST = 'trailersToAssignListStore'
export const DELIVERY_SITE_DROPDOWN_LIST = 'deliverySiteToAssignListStore'
export const WASTE_DELIVERY_SITE_DROPDOWN_LIST = 'wasteDeliverySiteToAssignListStore'
export const COLLECTION_SITE_DROPDOWN_LIST = 'collectionSiteToAssignListStore'
export const SILOS_DROPDOWN_LIST = 'silosToAssignListStore'
export const JOBS_LIST_STATUS_FILTER_STORE = 'jobsListStatusFilterStore'
export const JOBS_LIST_EMPLOYEE_FILTER_STORE = 'jobsListEmployeeFilterStore'
export const JOBS_LIST_CUSTOMER_FILTER_STORE = 'jobsListCustomerFilterStore'
export const JOBS_LIST_AD_PLANT_FILTER_STORE = 'jobsListAdPlantFilterStore'
export const JOBS_LIST_FARM_FILTER_STORE = 'jobsListFarmFilterStore'
export const JOBS_LIST_VEHICLE_FILTER_STORE = 'listVehicleFilterStore'
export const TIMESHEET_TYPE_FILTER_STORE = 'timesheetTypeFilterStore'
export const PRODUCT_TYPE_FILTER_STORE = 'productTypeFilterStore'
export const PRODUCT_CATEGORY_FILTER_STORE = 'productCategoryFilterStore'
